import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { t } from "../../i18n";

const TermsPage = () => {
    const { lang } = useLanguage();

    const ContentTR = () => (
        <div className="max-w-none space-y-8 text-foreground/80 leading-relaxed">
            <section className="bg-gray-50 p-6 rounded-lg border border-black/10">
                <h2 className="text-xl font-bold text-foreground uppercase tracking-wider mb-4">İNTERNET SİTESİ KULLANIM KOŞULLARI VE YASAL UYARI</h2>
                <p className="text-sm">
                    <strong>1. TARAFLAR VE KONU</strong><br />
                    İşbu Kullanım Koşulları ("Sözleşme"), [PROFİNOKS ENDRÜSTRİYEL MUTFAK EKİP. İNŞ. TUR. YAPI MALZ. SAN. VE TİC. LTD. ŞTİ.] ("Site Sahibi") tarafından işletilen [profinoks.com , profinoks.com.tr , profinoks.net] ("Site") internet sitesinin kullanımına ilişkin şartları belirlemektedir.
                </p>
            </section>

            <section className="space-y-4">
                <h2 className="text-xl font-bold text-foreground border-l-4 border-primary pl-4 uppercase tracking-wider">2. HİZMETİN KAPSAMI</h2>
                <p>
                    Site Sahibi, Site üzerinden endüstriyel mutfak ekipmanları konusunda içerik paylaşımı, bilgilendirme veya hizmet sunumu gerçekleştirmektedir. Site Sahibi, Site üzerinden sunulan hizmetleri dilediği zaman değiştirme hakkını saklı tutar.
                </p>
            </section>

            <section className="space-y-4">
                <h2 className="text-xl font-bold text-foreground border-l-4 border-primary pl-4 uppercase tracking-wider">3. FİKRİ MÜLKİYET HAKLARI</h2>
                <p>
                    Sitede yer alan tüm metinler, grafikler, logolar, görseller ve diğer içerikler, Site Sahibine aittir ve ulusal/uluslararası telif hakkı yasalarıyla korunmaktadır.
                </p>
            </section>

            <section className="space-y-4 text-sm bg-gray-50 p-6 rounded-lg border border-black/5">
                <h2 className="text-lg font-bold text-foreground uppercase tracking-wider">4. İLETİŞİM</h2>
                <div className="mt-4 space-y-1">
                    <p><strong>Unvan:</strong> PROFİNOKS ENDRÜSTRİYEL MUTFAK EKİP. İNŞ. TUR. YAPI MALZ. SAN. VE TİC. LTD. ŞTİ.</p>
                    <p><strong>Adres:</strong> Firuzköy Mah. Mezarlık Üstü Cad. No:13 34325 Avcılar/İstanbul</p>
                    <p><strong>E-posta:</strong> info@profinoks.com.tr</p>
                </div>
            </section>
        </div>
    );

    const ContentEN = () => (
        <div className="max-w-none space-y-8 text-foreground/80 leading-relaxed">
            <section className="bg-gray-50 p-6 rounded-lg border border-black/10">
                <h2 className="text-xl font-bold text-foreground uppercase tracking-wider mb-4">WEBSITE TERMS OF USE AND LEGAL NOTICE</h2>
                <p className="text-sm">
                    <strong>1. PARTIES AND SUBJECT</strong><br />
                    These Terms of Use ("Agreement") determine the conditions for the use of the [profinoks.com, profinoks.com.tr, profinoks.net] ("Site") website operated by [PROFINOKS INDUSTRIAL KITCHEN EQUIP. CONST. TUR. LTD. STI.] ("Site Owner").
                </p>
            </section>

            <section className="space-y-4">
                <h2 className="text-xl font-bold text-foreground border-l-4 border-primary pl-4 uppercase tracking-wider">2. SCOPE OF SERVICE</h2>
                <p>
                    The Site Owner provides content sharing, information, or service presentation on industrial kitchen equipment through the Site. The Site Owner reserves the right to change the services offered through the Site at any time.
                </p>
            </section>

            <section className="space-y-4">
                <h2 className="text-xl font-bold text-foreground border-l-4 border-primary pl-4 uppercase tracking-wider">3. INTELLECTUAL PROPERTY RIGHTS</h2>
                <p>
                    All texts, graphics, logos, images, and other content on the Site belong to the Site Owner and are protected by national/international copyright laws.
                </p>
            </section>

            <section className="space-y-4 text-sm bg-gray-50 p-6 rounded-lg border border-black/5">
                <h2 className="text-lg font-bold text-foreground uppercase tracking-wider">4. CONTACT</h2>
                <div className="mt-4 space-y-1">
                    <p><strong>Title:</strong> PROFINOKS INDUSTRIAL KITCHEN EQUIP. CONST. TUR. LTD. STI.</p>
                    <p><strong>Address:</strong> Firuzköy Mah. Mezarlık Üstü Cad. No:13 34325 Avcılar/İstanbul</p>
                    <p><strong>Email:</strong> info@profinoks.com.tr</p>
                </div>
            </section>
        </div>
    );

    return (
        <div className="mt-[122px] md:pt-[130px] lg:pt-[140px] bg-background pb-20 text-foreground min-h-screen">
            <div className="mx-auto max-w-4xl px-4 py-12">
                <header className="mb-12 border-b border-black/10 pb-8">
                    <h1 className="text-3xl md:text-4xl font-semibold tracking-tight uppercase text-primary">
                        {t(lang, "legal.termsTitle")}
                    </h1>
                    <p className="mt-4 text-muted-foreground text-sm">
                        {t(lang, "legal.lastUpdate")}: 17.02.2026
                    </p>
                </header>

                {lang === "tr" ? <ContentTR /> : <ContentEN />}
            </div>
        </div>
    );
};

export default TermsPage;
